module.exports = __webpack_public_path__ + "static/img/icon_money.de099cbc.png";